export const isGoogleFont = (fontUrl) => fontUrl.startsWith('https://fonts.googleapis.com');
